import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { IPersonalNotificationsItem } from '@fi-app/personal-notifications/personal-notifications';

@Injectable()
export class PersonalNotificationsService {
    constructor(private fiBackend: FiBackendService) {}

    getNewPersonalNotificationsCount() {
        return this.fiBackend.fetchData<number>('Notification/Notification/GetUnseenPersonalNotificationsCount');
    }

    getPersonalNotifications(offset, numberOfRecordsToTake) {
        return this.fiBackend.fetchDataPost<IPersonalNotificationsItem[]>(
            'Notification/Notification/GetPersonalNotifications',
            {
                Offset: offset,
                NumberOfRecordsToTake: numberOfRecordsToTake,
            },
        );
    }

    markAllPersonalNotificationsAsSeen(reqConfig?) {
        return this.fiBackend.fetchDataPost<void>(
            'Notification/Notification/MarkAllPersonalNotificationsAsSeen',
            undefined,
            reqConfig,
        );
    }

    markPersonalNotificationsAsVisited(notificationIds) {
        return this.fiBackend.fetchDataPost(
            'Notification/Notification/MarkPersonalNotificationsAsVisited',
            notificationIds,
        );
    }

    markAllPersonalNotificationsAsVisited() {
        return this.fiBackend.fetchDataPost<void>('Notification/Notification/MarkAllPersonalNotificationsAsVisited');
    }

    getUnvisitedPersonalNotificationsCount() {
        return this.fiBackend.fetchData<number>('Notification/Notification/GetUnvisitedPersonalNotificationsCount');
    }
}
